import type { SubscriptionProviderConfig } from "@voxmedia/duet-context/context/config-context";

export const MEMBERFUL_URL = process.env.NEXT_PUBLIC_MEMBERFUL_URL || "";
export const MEMBERFUL_OAUTH_TOKEN_URL = `${MEMBERFUL_URL}/oauth/token`;
export const MEMBERFUL_SESSION_COOKIE_NAME = "duet:memberful-session";
export const MEMBERFUL_REDIRECT_QUERY_PARAM = "memberfulRedirect";

export const memberfulConfig: SubscriptionProviderConfig = {
  subscriptionProviderUrl: MEMBERFUL_URL,
};
